import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendEstablish } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendEstablishState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendEstablishInitialState: JobRecommendListForTrendEstablishState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendEstablishSlice = createSlice({
  name: 'jobRecommendListForTrendEstablish',
  initialState: jobRecommendListForTrendEstablishInitialState,
  reducers: {
    setInitialDisplayFlagEstablish: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendEstablish.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(getJobListForTrendEstablish.fulfilled, (state, action) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
      state.jobRecommendListForTrend.entity = action.payload;
    });
    builder.addCase(getJobListForTrendEstablish.rejected, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
    });
  },
});

// Create Action
export const { setInitialDisplayFlagEstablish } =
  jobRecommendListForTrendEstablishSlice.actions;

// reducer
export const jobRecommendListForTrendEstablishReducer =
  jobRecommendListForTrendEstablishSlice.reducer;

interface State {
  jobRecommendListForTrendEstablish: JobRecommendListForTrendEstablishState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendEstablishLoadingSelector = <
  S extends State,
>(
  state: S
) => state.jobRecommendListForTrendEstablish?.jobRecommendListForTrend.loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendEstablishEntitySelector = <
  S extends State,
>(
  state: S
) => state.jobRecommendListForTrendEstablish?.jobRecommendListForTrend.entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagEstablishSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendEstablish.initialDisplayFlag;
